module.exports = __webpack_public_path__ + "static/img/logo.72a3471.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 568
// module chunks = 1